import { render, staticRenderFns } from "./DialogUpdateBot.vue?vue&type=template&id=6bc2a054&scoped=true"
import script from "./DialogUpdateBot.vue?vue&type=script&lang=js"
export * from "./DialogUpdateBot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2a054",
  null
  
)

export default component.exports